import { config } from '../../../../config/config';
import { ConfigSchema } from '../../../../config/types';

/**
 * The absolute music24-api address a token is issued for — what a script outside
 * the app must call. The in-app client uses the relative `/api_api/` proxy path,
 * which is useless in a snippet, so this reads the public origin instead.
 */
export const apiBaseUrlFor = (appConfig: Pick<ConfigSchema, 'music24ApiPublicURL'>): string =>
  `${appConfig.music24ApiPublicURL}trpc`;

export const API_BASE_URL = apiBaseUrlFor(config);

/** Requests per minute per user, shared by the HTTP endpoints and the MCP tools. */
export const API_RATE_LIMIT_PER_MINUTE = 30;

/** Mirrors `MAX_ACTIVE_TOKENS` in `music24-api/src/trpc/music24ApiTokens.router.ts`. */
export const API_MAX_ACTIVE_TOKENS = 5;
